export default "__VITE_ASSET__BMDhC1Ao__"